import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Header } from "semantic-ui-react";
import TourLayoutWrapper from "../components/TourLayoutWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import TourNav from "../constants/TourNav";
import MediaItemDownloadStore from "~/stores/Media/MediaItemDownloadStore";
import BulkDownload from "./Download/BulkDownload";
import IndividualDownload from "./Download/IndividualDownload";
import VideoDownload from "./Download/VideoDownload";
import FlyerDownload from "./Download/FlyerDownload";
import Tour from "~/models/Tour";
import User from "~/models/User";
import "../styles/Download.less";

@observer
class DownloadPage extends Component {
  mediaItemDownloadStore = null;

  constructor(props) {
    super(props);
    document.title = "Tour - Download";
    this.mediaItemDownloadStore = new MediaItemDownloadStore();
  }

  componentDidMount() {
    const { showError, query, tourId } = this.props;

    if (query && query.token) {
      this.mediaItemDownloadStore.token = query.token;
    }

    this.mediaItemDownloadStore.load(tourId).catch(error => showError(error.message));
    window.scrollTo(0, 0);
  }

  render() {
    const {
      isLoaded,
      isLoading,
      mediaItems,
      formStore,
      zipDownloadUrl,
      flyerUrl,
      exportedTourVideoBrandedUrl,
      exportedTourVideoUnbrandedUrl,
      smallPhotos,
      largePhotos,
      mlsPhotos,
      printQualityPhotos,
      smallVirtualTours,
      largeVirtualTours,
      smallVideoClips,
      largeVideoClips,
      fhdVideoClips,
      hasPhotos,
      hasVirtualTours,
      hasVideoClips,
      downloadSize,
      filesSelectedCount,
      zipFilename,
      token,
    } = this.mediaItemDownloadStore;
    const { setProperty, model } = formStore;
    const { tourId, tour, user, t } = this.props;

    if (isLoading || !isLoaded) {
      return <ContentLoader />;
    }

    return (
      <div id="tour-download">
        <Header as="h2" content={t("clientPanelMisc:downloadCenter")} />
        <BulkDownload
          zipDownloadUrl={zipDownloadUrl}
          smallPhotos={smallPhotos}
          largePhotos={largePhotos}
          mlsPhotos={mlsPhotos}
          printQualityPhotos={printQualityPhotos}
          smallVirtualTours={smallVirtualTours}
          largeVirtualTours={largeVirtualTours}
          smallVideoClips={smallVideoClips}
          largeVideoClips={largeVideoClips}
          fhdVideoClips={fhdVideoClips}
          hasPhotos={hasPhotos}
          hasVirtualTours={hasVirtualTours}
          hasVideoClips={hasVideoClips}
          downloadSize={downloadSize}
          filesSelectedCount={filesSelectedCount}
          zipFilename={zipFilename}
          setProperty={setProperty}
          model={model}
        />
        <VideoDownload
          tourId={tourId}
          exportedTourVideoBrandedUrl={exportedTourVideoBrandedUrl}
          exportedTourVideoUnbrandedUrl={exportedTourVideoUnbrandedUrl}
          editDisabled={tour && tour.acl.videoRequest === false}
          user={user}
        />
        {flyerUrl && (
          <FlyerDownload tourId={tourId} flyerUrl={flyerUrl} editDisabled={tour && tour.acl.flyer === false} />
        )}
        <IndividualDownload
          mediaItems={mediaItems}
          token={token}
          model={model}
          setProperty={setProperty}
          tourIsArchived={tour.isArchived}
        />
      </div>
    );
  }
}

DownloadPage.propTypes = {
  tourId: PropTypes.number.isRequired,
  tour: PropTypes.instanceOf(Tour),
  user: PropTypes.instanceOf(User),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourLayoutWrapper(DownloadPage, TourNav.DOWNLOAD));
